/**
 * The record-page routes the web and the phone both call (T3226): a Location's
 * pin and address verify, and a note's replies. One builder each, so an id with
 * a slash in it is encoded the same way in both apps. 🔨 Relative to the API's
 * own root, so no path repeats the base's `/api`.
 */
export const RECORD_PAGES_PATH = '/pages';

/** The company's open sites, in the shape the Site picker reads (decision 0669), for the web's forms and the phone's Default billing site. */
export function companyBillingSitesPath(companyId: string): string {
  return `${RECORD_PAGES_PATH}/companies/${encodeURIComponent(companyId)}/billing-sites`;
}

/** A Location's County picks from the Census Bureau's counties of its state (decision 0737), the web's Location form's read and the phone's. */
export const COUNTIES_PATH = '/tax/counties';

/** The official counties of one state. */
export function countiesPath(stateCode: string): string {
  return `${COUNTIES_PATH}?state=${encodeURIComponent(stateCode)}`;
}

/** A Location's pin, `POST` with the point and `DELETE` with nothing (decisions 0674, 4201). */
export function locationPinPath(locationId: string): string {
  return `${RECORD_PAGES_PATH}/locations/${encodeURIComponent(locationId)}/pin`;
}

/** Verify Address on the stored address of one Location (decisions 0338, 0673). */
export function verifyLocationPath(locationId: string): string {
  return `${RECORD_PAGES_PATH}/locations/${encodeURIComponent(locationId)}/verify`;
}

/** 🔒 Verified by User (decision 7460): a person confirms the house number of an Estimated address by hand. */
export function verifiedByUserPath(locationId: string): string {
  return `${RECORD_PAGES_PATH}/locations/${encodeURIComponent(locationId)}/verified-by-user`;
}

/** Where a note's replies are written (decision 0671). */
export function noteCommentsPath(noteId: string): string {
  return `${RECORD_PAGES_PATH}/notes/${encodeURIComponent(noteId)}/comments`;
}

/** Where one reply is deleted, by its author or an administrator (decision 0671). */
export function noteCommentPath(noteId: string, commentId: string): string {
  return `${noteCommentsPath(noteId)}/${encodeURIComponent(commentId)}`;
}
